export const syncedDraftKey = (userId: string, day: string) => `climbwriter-cloud-synced:${userId}:${day}`;

export async function draftFingerprint(text: string) {
  const bytes = new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)));
  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
}

export async function matchesSyncedDraft(storage: Pick<Storage, 'getItem'>, userId: string, day: string, text: string) {
  try {
    const saved = storage.getItem(syncedDraftKey(userId, day));
    return Boolean(saved && saved === await draftFingerprint(text));
  } catch { return false; }
}

export function canApplyCloudDraft({ cloud, current, local, knownBase, tabCopy, hasRecovery }: {
  cloud: string;
  current: string;
  local: string;
  knownBase: boolean;
  tabCopy: string | null;
  hasRecovery: boolean;
}) {
  if (hasRecovery || (tabCopy !== null && tabCopy !== current)) return false;
  return current === cloud || (current === local && knownBase);
}
